__turbopack_context__.v({
  "highlighted": "Table-module__paReHW__highlighted",
  "lineClamp": "Table-module__paReHW__lineClamp",
  "rowTitle": "Table-module__paReHW__rowTitle",
  "wrpr": "Table-module__paReHW__wrpr",
});
